import type { MatchData } from '@kira-dancer/nuxt-common'
import { useGameSpecificEvents } from '~/composables/tracking-events/use-game-specific-events'
import { IFrameGameURLEnum } from '@kira-dancer/nuxt-common/enums'
import { SportType } from '~/enums/sports'
import { DATE_TIME_FORMAT } from '@kira-dancer/nuxt-common/constants'

export function usePLayGameSports() {
  const { playKSportGame, playASportGame } = useSports()
  const { trackingGameStarted } = useGameSpecificEvents()

  const playSportGame = (sportType: string, matchData: MatchData): void => {
    if (sportType === SportType.KSports) {
      playKSportGame(matchData)
      trackingGameStarted({
        gameId: matchData.matchId,
        gameType: 'hot match',
        gameName: 'K sport',
      })
      return
    }
    if (sportType === SportType.PSports) {
      playASportGame(matchData)
      trackingGameStarted({
        gameId: matchData.matchId,
        gameType: 'hot match',
        gameName: 'P sport',
      })
      return
    }
  }

  const isCheckEmptyPSport = (match: MatchData): boolean => {
    return (
      !match.athena_ahFT &&
      !match.athena_ahHT &&
      !match.athena_overFT &&
      !match.athena_overHT &&
      !match.athena_winFT &&
      !match.athena_winHT
    )
  }

  const isCheckEmptyKSport = (match: MatchData): boolean => {
    return (
      !match.ahHT &&
      !match.overHT &&
      !match.overFT &&
      !match.ahFT &&
      !match.winFT &&
      !match.winHT
    )
  }
  
  const getLinkKSportsGame = (matchData: MatchData): string => {
    if (matchData.match_id) {
      return `${IFrameGameURLEnum.K_SPORTS}?eventId=${matchData.match_id}&leagueId=${matchData.league_id}`
    }
    return IFrameGameURLEnum.K_SPORTS
  }

  const getLinkPSportsGame = (matchData: MatchData): string => {
    if (matchData.athena_match_id) {
      return `${IFrameGameURLEnum.C_SPORTS}?mid=${matchData.athena_match_id}`
    }
    return IFrameGameURLEnum.C_SPORTS
  }

  const formatMatchTime = (match: MatchData) => {
    if (!toDate(match.text_time).isValid()) {
      return '_'
    }
    const formattedDate = formatDate(
      match.text_time,
      DATE_TIME_FORMAT.DATE_FORMAT_MAINTAIN,
    )
    return formattedDate?.split(' ')
  }
  
  return {
    getLinkKSportsGame,
    getLinkPSportsGame,
    isCheckEmptyPSport,
    isCheckEmptyKSport,
    playSportGame,
    formatMatchTime
  }
}

